import actionTypes from '../constants/actionTypes';
import { getDataForClosure } from '../../../../../../services/pos/transactions';

export const getDataForClosureAction = () => async (dispatch) => {
  const { CLOSURE_DATA_FETCH, CLOSURE_DATA_SUCCESS, CLOSURE_DATA_ERROR} = actionTypes;
  dispatch({ type: CLOSURE_DATA_FETCH });
  try {
    const payload = await getDataForClosure();
    dispatch({ type: CLOSURE_DATA_SUCCESS, payload: payload });
  } catch (error) {
    const errorResponse = error.response;
    dispatch({ type: CLOSURE_DATA_ERROR, error: errorResponse });
  }
};
